import axios from 'axios';

const instance = axios.create({
  baseURL:
    process.env.REACT_APP_API_BASE_URL ||
    'http://localhost:8000/api',
});

instance.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('_token');

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const isAuthRequest = requestUrl.startsWith('/auth/');

    if (status === 401 && !isAuthRequest) {
      const hadSession = Boolean(
        localStorage.getItem('_token')
      );

      localStorage.removeItem('_token');
      localStorage.removeItem('_refreshToken');
      localStorage.removeItem('user');
      localStorage.removeItem('role');

      if (hadSession) {
        window.location.replace('/');
      }
    }

    return Promise.reject(error);
  }
);

export default instance;